<template>
  <v-row class="fill-height">
    <v-col :cols="stream" style="padding: 0%" class="fill-height">
      <iframe
        v-if="liveEvent1 || liveEvent2"
        :src="liveStreamLink"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        style="width:100%; height:100%;"
      />
      <div v-else style="margin-top: 15%">
        <h1 align="center" style="font-size: 80px">
          <strong>Live Event Date: </strong>
        </h1>
        <p align="center" style="font-size: 20px">
          July 8 - 5:30 to 7:00 pm MST <br />
          July 13 - 1:30 to 3:00 pm MST
        </p>
      </div>
    </v-col>
    <v-col :cols="comment" class="fill-height" style="padding: 0%">
      <v-card height="100%">
        <v-row v-if="!commentMode" style="padding: 5%">
          <p>
            {{ $t(`liveEvent.welcome`) }}
            <br /><br />
            {{ $t(`liveEvent.access`) }}
            <router-link to="/" target="_blank"
              >https://elpaso.scoutfeedback.com/.</router-link
            >
          </p>
          <br />
          {{ $t(`liveEvent.why`) }}
          <ul style="padding-left: 15%">
            <li>{{ $t(`liveEvent.reason1`) }}</li>
            <li>{{ $t(`liveEvent.reason2`) }}</li>
          </ul>
          <br />
          {{ $t(`liveEvent.scout`) }}
          <br /><br />
          <v-row justify="center" align="center">
            <v-btn
              dark
              href="https://hntb.webex.com/hntb/j.php?MTID=m6b1237868d6f0b9a974ced79eb7692f2"
              target="_blank"
              color="#388E3C"
            >
              {{ $t(`liveEvent.join`) }}
            </v-btn>
          </v-row>
        </v-row>
        <v-row v-else style="padding: 5%;">
          <v-col cols="12">
            <v-text-field
              v-model="liveEventName"
              :label="$t(`liveEvent.name`)"
              outlined
              full-width
            >
            </v-text-field>
            <v-textarea
              v-model="liveEventComment"
              :label="$t(`liveEvent.comment`)"
              outlined
              full-width
            ></v-textarea>
            <v-btn
              class="text-center"
              outlined
              :disabled="!liveEventComment.trim() || sending"
              @click="submitComment"
            >
              {{ $t(`liveEvent.submit`) }}
            </v-btn>
            <br /><br />
            <v-alert type="success" v-if="finished">
              <b> {{ $t(`liveEvent.success`) }} </b>
            </v-alert>
            <v-alert type="error" v-if="error">
              <b>
                {{ $t(`liveEvent.failure`) }}
              </b>
            </v-alert>
          </v-col>
        </v-row>
        <v-divider></v-divider><br />
        <v-row justify="center" align="center">
          <div class="text-center">
            <v-btn @click="toggleComment"> {{ toggleText }} </v-btn>
          </div>
        </v-row>
        <br />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "LiveEvent",
  data: () => ({
    liveEventComment: "",
    liveEventName: "",
    commentMode: false,
    finished: false,
    error: false,
    sending: false
  }),
  methods: {
    ...mapActions({
      addResponse: "response/addResponse"
    }),
    toggleComment() {
      this.commentMode = !this.commentMode;
    },
    submitComment() {
      const payload = {
        survey: 4, // Live Event Comment
        survey_taker_id: 1, // anonymous user
        response_json: {
          name: this.liveEventName,
          comment: this.liveEventComment
        },
        comment_location: [],
        survey_metadata: 4 // Live Event Comment metadata
      };
      this.sending = true;
      this.addResponse(payload)
        .then(() => {
          this.finished = true;
          setTimeout(() => {
            this.sending = false;
            this.finished = false;
          }, 5000);
        })
        .catch(() => {
          this.error = true;
          setTimeout(() => {
            this.sending = false;
            this.error = false;
          }, 5000);
        });
    }
  },
  computed: {
    toggleText() {
      if (this.commentMode) {
        return this.$t("liveEvent.info");
      }
      return this.$t("liveEvent.comment");
    },
    liveEvent1() {
      const currentTime = new Date();
      const liveEventStart = new Date("2020-07-08T23:29:00Z");
      const liveEventEnd = new Date("2020-07-09T02:30:00Z");
      return currentTime > liveEventStart && currentTime < liveEventEnd;
    },
    liveEvent2() {
      const currentTime = new Date();
      const liveEventStart = new Date("2020-07-13T19:00:00Z");
      const liveEventEnd = new Date("2020-07-13T21:30:00Z");
      return currentTime > liveEventStart && currentTime < liveEventEnd;
    },
    liveStreamLink() {
      if (this.liveEvent1) {
        return "https://www.youtube.com/embed/zWUeNCKHY5s?rel=0";
      } else if (this.liveEvent2) {
        return "https://www.youtube.com/embed/rlay-x_qClY?rel=0";
      } else {
        return "https://www.youtube.com/embed/SDxwAV-hLZU?rel=0";
      }
    },
    stream() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 9;
    },
    comment() {
      if (this.$vuetify.breakpoint.xs) {
        return 12;
      }
      return 3;
    }
    // Just in case we need this later

    // isIE() {
    //   const sAgent = window.navigator.userAgent;
    //   const Idx = sAgent.indexOf("MSIE");
    //   let version = 0;

    //   /* eslint-disable */
    //   if (Idx > 0) {
    //     version = parseInt(sAgent.substring(Idx+ 5, sAgent.indexOf(".", Idx)));
    //   } else if (!!navigator.userAgent.match(/Trident\/7\./)) {
    //     version = 11;
    //   } else {
    //     version = 0;
    //   }

    //   return (version > 0)
    // }
  }
};
</script>
